module.exports = __webpack_public_path__ + "static/media/julia-set.0255adda.mp4";